import React, { useEffect } from "react";
import { IndividualDrilldownSummaryDto } from "../../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualDrilldownSummaryDto";
import { EntriesPerPage } from "../../../../../Component/Model/Table/Table";
import {defaultObject} from "../../../../../Component/Model/helpers";
import {
  WorkforceProfileGoalsAndTargetsService
} from "../../../../../Component/Api/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileGoalsAndTargetsService";
import {EEOccupationalLevel} from "../../../../../Component/Model/Enum/EmploymentEquity";
import {Gender, RaceTypes, UserActivityActionType} from "../../../../../Component/Model/Enum/BEE123Enums";
import {IndividualDrilldownMapper} from "../../../../Common/EEA2/IndividualDrilldownCommon";
import {DataTable} from "../../../../../Component/Common/Components/DataTable/DataTable";
import {IndividualModal} from "../../../../Common/Individual/IndividualModal";
import {
  WorkforceProfileOccupationalLevelTargets
} from "../../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileOccupationalLevelTargets";
import { UserActivityService } from "../../../../../Component/Api/UserActivity/UserActivityService";

interface IProps {
  occupationalLevel: EEOccupationalLevel;
  gender: Gender;
  race: RaceTypes;
  isDisabled: boolean;
  scorecardId: string;
  excludeTemporaryEmployees?: boolean;
  date?: Date;
  section?: string;
}

export const WorkForeProfileDrilldown = (props: IProps) => {
  const [individualData, setIndividualData] = React.useState<IndividualDrilldownSummaryDto[]>(defaultObject);
  const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
  const [pageNumber, setPageNumber] = React.useState<number>(1);
  const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState<string>();

  const [selectedIndividualId, setSelectedIndividualId] = React.useState<number>(0);
  const [showIndividualModal, setShowIndividualModal] = React.useState<boolean>(false);

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const searchValueChanged = (value: string) => {
    setSearchValue(value);
  };

  const drilldownSearchRequest: WorkforceProfileOccupationalLevelTargets.OccupationalLevelDrilldownRequest = {
    scorecardId: props.scorecardId,
    gender: props.gender,
    eeOccupationalLevel: props.occupationalLevel,
    race: props.race,
    pageNumber: pageNumber,
    pageSize: entriesPerPage.defaultValue as number,
    isDisabled : props.isDisabled,
    date: props.date,
    excludeTemporaryEmployees: props.excludeTemporaryEmployees,
    searchValue: searchValue
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let searchResult = await WorkforceProfileGoalsAndTargetsService
          .GetOccupationalLevelDrilldown(drilldownSearchRequest);

      if (searchResult.data) {
        setIndividualData(searchResult.data.results);
        setFilteredItemsCount(searchResult.data.filteredItemsCount);
        setTotalItemsCount(searchResult.data.totalItemsCount);

        props.section && UserActivityService.createActivityLog({
          section: props.section,
          actionType: UserActivityActionType.View,
          actionDescription: "View employee structure",
          scorecardId: props.scorecardId,
          requestUrl: window.location.href
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps
  
  const onEdit = (id: number) => {
    setSelectedIndividualId(id);
    setShowIndividualModal(true);
  };

  const closeIndividualModal = () => {
    setShowIndividualModal(false);
    setSelectedIndividualId(0);
  };

  const drilldownTableData = IndividualDrilldownMapper(individualData, onEdit);
  return (
    <>
      <div style={{ marginTop: "-32px" }}>
        <DataTable
          table={drilldownTableData}
          entriesPerPage={entriesPerPage}
          pageNumber={pageNumber}
          filteredItemsCount={filteredItemsCount}
          totalItemsCount={totalItemsCount}
          entriesPerPageChanged={entriesPerPageChanged}
          pageNumberChanged={pageNumberChanged}
          isLoading={isLoading}
          searchValueChanged={searchValueChanged}
          canSearch={true}
        ></DataTable>
      </div>
      {showIndividualModal && (
        <IndividualModal
          showIndividualModal={showIndividualModal}
          closeIndividualModal={closeIndividualModal}
          scorecardId={props.scorecardId}
          id={selectedIndividualId}
          section={props.section}
        />
      )}
    </>
  );
};
